import React from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Chip, Typography, Box,
} from '@mui/material';

const formatPaise = (p) => `₹${(p / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const fmtDate = (s) => s ? new Date(s).toLocaleString('en-IN') : '-';

const entryColor = (type) => type === 'DEBIT' ? '#d32f2f' : '#388e3c';

const JournalLegsTable = ({ entries = [] }) => {
  if (!entries.length) {
    return (
      <Box sx={{ py: 2, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">No legs in this journal</Typography>
      </Box>
    );
  }

  const totalDebit = entries.filter(e => e.entry_type === 'DEBIT').reduce((s, e) => s + e.amount_paise, 0);
  const totalCredit = entries.filter(e => e.entry_type === 'CREDIT').reduce((s, e) => s + e.amount_paise, 0);
  const balanced = totalDebit === totalCredit;

  return (
    <Box>
      <Box sx={{ display: 'flex', gap: 2, mb: 1, alignItems: 'center' }}>
        <Typography variant="body2">
          Total Debit: <strong style={{ color: '#d32f2f' }}>{formatPaise(totalDebit)}</strong>
        </Typography>
        <Typography variant="body2">
          Total Credit: <strong style={{ color: '#388e3c' }}>{formatPaise(totalCredit)}</strong>
        </Typography>
        <Chip
          label={balanced ? 'Balanced' : 'UNBALANCED'}
          size="small"
          color={balanced ? 'success' : 'error'}
        />
      </Box>
      <TableContainer component={Paper} elevation={1}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>#Seq</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Account</TableCell>
              <TableCell align="right">Amount</TableCell>
              <TableCell>Event</TableCell>
              <TableCell>ConsultID</TableCell>
              <TableCell>Tick</TableCell>
              <TableCell>Hash</TableCell>
              <TableCell>Created</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {entries.map((e) => (
              <TableRow key={e.entry_uuid}>
                <TableCell>{e.sequence_no}</TableCell>
                <TableCell>
                  <Chip
                    label={e.entry_type}
                    size="small"
                    sx={{ bgcolor: entryColor(e.entry_type), color: 'white', fontWeight: 'bold' }}
                  />
                </TableCell>
                <TableCell>
                  <Typography variant="caption">{e.account_type}</Typography>
                </TableCell>
                <TableCell align="right" sx={{ color: entryColor(e.entry_type), fontWeight: 'bold' }}>
                  {formatPaise(e.amount_paise)}
                </TableCell>
                <TableCell>
                  <Typography variant="caption">{e.event_type}</Typography>
                </TableCell>
                <TableCell>{e.consultation_id ?? '-'}</TableCell>
                <TableCell>{e.tick_number ?? '-'}</TableCell>
                <TableCell>
                  <Typography variant="caption" sx={{ fontFamily: 'monospace', fontSize: '0.65rem' }} noWrap>
                    {e.entry_hash?.slice(0, 12)}…
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="caption" noWrap>{fmtDate(e.created_at)}</Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default JournalLegsTable;
